<template>
  <v-layout column align-start justify-center>
    <v-toolbar
      style="position: -webkit-sticky; /* Safari */position: sticky; z-index: 3"
    >
      <v-toolbar-title>
        <v-icon>help_outline</v-icon>Tips og triks
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="hideDrawer">
        <v-icon>chevron_left</v-icon>
      </v-btn>
    </v-toolbar>

    <div style="width: 100%" v-for="(category, i) in helpItems" :key="i">
      <h2 class="body-1 ma-2 ml-4 mt-4" style="font-weight: bold">
        {{ category.category }}
      </h2>
      <v-expansion-panel class="mt-0">
        <v-expansion-panel-content v-for="(item, i) in category.items" :key="i">
          <template v-slot:header>
            <div>{{ item.title }}</div>
          </template>
          <v-card>
            <v-card-text class="secondary" v-html="item.text"></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "TipsAndTricks",
  computed: {
    ...mapState([
      "currentlyOpenedProject",
      "appHelpEmailSubject",
      "appPublicUrl"
    ])
  },
  methods: {
    ...mapActions(["setShowSideMenu"]),
    hideDrawer() {
      this.setShowSideMenu(false);
    }
  },
  data() {
    return {
      helpItems: [
        {
          category: "Kartlag og generelt",
          items: [
            {
              title: "Hvordan legger jeg til kartlag?",
              text:
                "Velg 'Legg til innhold' øverst i kartlagslisten. Du vil da få opp en meny der du kan legge til kartlag fra NVE, tegnelag, eller filer fra din egen datamaskin."
            },
            {
              title: "Hvordan fjerner jeg kartlag?",
              text:
                "Hold musepekeren over kartlaget du ønsker å fjerne, klikk på menyikonet (tre prikker), og velg 'Fjern kartlaget'."
            },
            {
              title: "Hvordan kan jeg justere synligheten på kartlag?",
              text:
                "Hold musepekeren over øyeikonet på kartlaget i kartlagslisten, og bruk musehjulet for å justere synligheten til kartlaget. Du kan også klikke på pilene over og under øyeikonet for å justere synligheten."
            },
            {
              title: "Hvordan nullstiller jeg rotasjonen i kartet?",
              text:
                "For å nullstille rotasjonen mot nord igjen klikker du på kompassknappen nederst til høyre i kartet."
            },
            {
              title: "Kan jeg endre rekkefølgen på kartlag?",
              text:
                "Ja. Dette gjør du ved å dra kartlaget opp eller ned i kartlagslisten til den posisjonen du ønsker å ha det. Kartet oppdateres automatisk når du slipper kartlaget på ønsket posisjon."
            },
            {
              title: "Kan jeg importere filer i kartet?",
              text:
                "Ja, du kan importere shape (zippet), geoJSON, KML og GPX filer. For å legge til en fil i kartet velger du 'Legg til innhold' i kartlagslisten, og deretter fanen 'Fil fra datamaskin'."
            },
            {
              title: "Kan jeg filtrere innholdet i et kartlag?",
              text:
                "Du kan filtrere innhold i vanlige kartlag (dvs. kartlag som ikke er raster eller tegnelag). Dette gjør du ved å holde musepekeren over kartlaget du ønsker å filtrere, og velge filterikonet. I dialogboksen som åpner seg har du enten mulighet til å designe en spørring mot kartlaget på en grafisk måte, eller skrive inn en SQL WHERE spørring direkte. Når du er klar velger du 'OK'. Kartet vil automatisk oppdateres til å kun inneholde elementene som tilfredsstiller spørringen du har lagt inn."
            },
            {
              title: "Hvordan endrer jeg bakgrunnskart?",
              text:
                "Bakgrunnskart endres ved hjelp av nedtrekksmenyen nederst til venstre i kartet. Det er foreløpig mulig å velge mellom 8 bakgrunnskart. Ta kontakt hvis du trenger andre bakgrunnskart enn dette."
            },
            {
              title: "Hvordan ser jeg metadata om kartlag?",
              text:
                "Metadata er kun tilgjengelig for noen kartlag. For å åpne metadata holder du musepekeren over kartlaget, og velger deretter 'info' ikonet."
            },
            {
              title: "Hvordan ser jeg beskrivelser av kartlag?",
              text:
                "De fleste av våre offisielle kartlag har en tekstlig beskrivelse som forklarer hva som vises i kartlaget. Du kan åpne beskrivelsen av et kartlag ved å holde musepekeren over kartlaget i kartlagslisten, og klikke på infoikonet."
            },
            {
              title: "Kan jeg se en tabellvisning av elementer i kartlag?",
              text:
                "Ja, du kan se tabellvisning av vanlige kartlag, men ikke for raster-kartlag og tegnelag. For å vise tabellen for et kartlag holder du musepekeren over kartlaget, og klikker på tabellsymbolet."
            }
          ]
        },
        {
          category: "Lagring og deling",
          items: [
            {
              title: "Kan jeg lagre kartvisningen og åpne igjen senere?",
              text:
                "Ja, du kan lagre kartvisningen ved å åpne hovedmenyen via menyikonet (hamburgerikonet) øverst til venstre, og deretter velge 'Lagre kart'. Når du gjør dette lagres det en kopi av kartvisningen på NVE sine servere. Det lagres også en referanse til kartet i nettleseren din slik at du på et senere tidspunkt kan åpne kartet igjen fra menyen. Det anbefales at du også tar vare på lenken til kartet i tilfelle nettleserhistorikken blir slettet, eller hvis du ønsker å åpne kartet fra en annen maskin."
            },
            {
              title: "Kan jeg dele en kartvisning med andre?",
              text:
                "Ja, du kan dele kartvisningen ved å velge 'Del kartet' i hovedmenyen. Du vil da bli bedt om å gi kartet et navn. Når du har gitt kartet et navn vil du få opp en dialogboks med lenke til kartet som du kan sende til andre."
            },
            {
              title: "Kan jeg oppdatere et kart jeg allerede har lagret?",
              text:
                "Ja. For å gjøre dette må du åpne kartet du allerede har lagret (se første punkt i denne kategorien), gjøre endringene du ønsker, og deretter gå til hovedmenyen ved å klikke på menyikonet øverst til venstre, og deretter velge 'Lagre kart'."
            },
            {
              title: "Kan jeg lagre en kopi av et kart andre har delt med meg?",
              text:
                "Ja. Dette gjøres ved å åpne kartet, velge menyikonet øverst til venstre, og deretter velge 'Lagre som'."
            }
          ]
        },
        {
          category: "Søk etter steder og elementer",
          items: [
            {
              title: "Hvordan søker jeg i kartet?",
              text:
                "Velg 'Søk' i menyen til venstre, og skriv deretter inn søketermen. Resultatene vises etterhvert som du skriver inn tekst. Klikk på et av resultatene for å gå til dette i kartet."
            },
            {
              title: "Kan jeg søke i fagdatabaser?",
              text:
                "Ja. Søkefunksjonen vil automatisk vise treff fra kartlagene som er lagt til i kartet. "
            }
          ]
        },
        {
          category: "Tegning og måling",
          items: [
            {
              title: "Hvordan tegner jeg i kartet?",
              text:
                "Klikk på tegnesymbolet i menyen til venstre for å aktivere tegning i kartet. Når du gjør dette vil du se en tegnemeny i kartet. Bruk denne menyen til å legge inn punkter, polygoner og linjer."
            },
            {
              title: "Hvordan måler jeg avstand eller areal?",
              text:
                "Klikk på målesymbolet i menyen til venstre for å aktivere måleverktøyet. Når du gjør dette vil du se en målemeny i kartet. Her velger du om du vil måle avstand eller areal, og klikker deretter i kartet for å tegne inn linjen/området du skal måle."
            },
            {
              title: "Kan jeg laste ned tegningene mine?",
              text:
                "Ja, du kan laste ned et tegnelag som en zippet shapefil. For å gjøre dette holder du musepekeren over tegnelaget i kartlagslisten, velger menyikonet (tre prikker), og deretter 'Eksporter til shapefil'"
            },
            {
              title: "Kan jeg kopiere geometri fra kartlag til tegnelag?",
              text:
                "Ja, du kan kopiere geometri fra et element i et kartlag ved å klikke på elementet i kartet, og deretter velge 'Kopier geometri' i informasjonsvinduet som dukker opp. Etter at elementet har blitt kopiert kan du lime det inn i et tegnelag ved å holde musepekeren over tegnelaget, velge menyikonet (tre prikker), og deretter 'lim inn geometri'."
            }
          ]
        },
        {
          category: "Utskrift og dataeksport",
          items: [
            {
              title: "Hvordan eksporterer jeg data?",
              text:
                "Eksport av data fra tegnelag er beskrevet under punktet 'Hvordan laster jeg ned tegningene mine?'. Eksport fra andre kartlag kan gjøres via tabellvisningen som åpnes ved å klikke på tabellikonet på et kartlag. Fra tabellvisningen må man bruke sjekkboksen til venstre i hver rad og krysse av de elementene man ønsker å laste ned. Deretter velger man 'Eksporter data' som ligger øverst til høyre i tabellvisningen. "
            },
            {
              title: "Hvordan skriver jeg ut kartet?",
              text:
                "Utskrift av kartet gjøres ved å velge 'Skriv ut' i menyen til venstre. Når man gjør dette vil du få frem en boks i kartet som illustrerer hvilken del av kartet som vil bli med på utskriften. Du kan justere størrelsen på denne boksen vha. målestokkfeltet i utskriftsfunksjonen. Du kan også justere andre innstillinger. Når du er klar klikker du på 'Eksporter' knappen i utskriftsmenyen. Når eksporten er klar vises det en lenke til denne nederst i utskriftsmenyen."
            },
            {
              title: "Utskriften blir uklar - hva gjør jeg?",
              text:
                "For å få så skarpe utskrifter som mulig anbefaler vi å bruke et vektorbakgrunnskart. Vi tilbyr vektor farge, vektor terreng og vektor grå, og du finner disse i nedtrekksmenyen nederst til venstre i kartet (og i hovedmenyen hvis du er på mobil)."
            }
          ]
        },
        {
          category: "3D visning",
          items: [
            {
              title: "Kan jeg skrive ut i 3D?",
              text:
                "Nei, ikke slik du er vant med fra et 2D kart. Du kan allikevel eksportere et bilde fra 3D visningen. Dette valget vil vises automatisk når du velger å skrive ut mens du er i 3D modus."
            },

            {
              title: "Hvordan aktiverer jeg 3D visning?",
              text:
                "3D visning aktiveres ved å klikke på 3D knappen nederst til høyre i kartet. Klikk på knappen igjen for å gå tilbake til 2D visning."
            },
            {
              title: "Hvorfor flimrer kartet i 3D visning?",
              text:
                "3D visning er foreløpig ganske nytt, og vi har ikke klart å luke ut alle problemer knyttet til flimring. Vi håper å rette dette opp i fremtidige versjoner."
            }
          ]
        },
        {
          category: "Ymse",
          items: [
            {
              title: "Kan jeg se koordinater for andre koordinatsystem?",
              text:
                "Ja, ved å velge knappen 'x/y' i menyen til venstre vil du få opp en meny nederst i kartet som viser koordinater. I denne menyen kan du velge andre koordinatsystemer. Ta gjerne kontakt dersom du ønsker at vi skal støtte andre koordinatsystemer enn de som ligger der i dag."
            },
            {
              title: "Hvilket koordinatsystem bruker løsningen?",
              text:
                "Løsningen bruker koordinatsystemet EUREF89 UTM33 (wkid: 25833)."
            },
            {
              title: "Hvordan ser jeg høydeprofilen for en linje?",
              text:
                "Du kan hente høydeprofiler for alle linjeelementer som vises i kartet, inkludert linjer du har tegnet inn selv. Dette gjøres ved å klikke på linjen i kartet, for deretter å velge 'Høydeprofil' i informasjonsvinduet som dukker opp."
            },
            {
              title: "Kan jeg utføre geometriske operasjoner?",
              text:
                "Ja, du kan utføre enkle geometriske operasjoner/analyser (f.eks. buffer, differanse, union), men kun på elementer som ligger i tegnelag. Hvis du ønsker å kjøre slike analyser på geometri fra andre kartlag må du først kopiere denne geometrien inn i et tegnelag. For å utføre geometriske operasjoner på et tegnelag holder du musepekeren over tegnelaget i kartlagslisten, og velger funksjonssymbolet. Du vil da få opp en dialogboks der du velger hvilken operasjon du vil bruke, og fyller inn parametere for denne funksjonen. Når du er klar velger du 'Kjør'. Resultatet fra operasjonen vil legges til i kartet som et eget tegnelag. "
            },
            {
              title: "Hvordan er NVE sine kartdata lisensiert?",
              text:
                'NVEs kartdata distribueres i henhold til <a href="https://data.norge.no/nlod/no">Norsk lisens for offentlige data (NLOD).</a>'
            },
            {
              title: "Kan jeg se nylige satelittbilder?",
              text:
                "Ja, vi tilbyr noen tjenester med oppdatere satelittbilder. Disse kan legges til via 'Legg til innhold' øverst i kartlagslisten. Når et satelittkartlag er lagt til kan man velge dato direkte ved hjelp av datofeltet på kartlaget i kartlagslisten."
            },
            {
              title: "Hvordan kan jeg se bilder fra NVEs fotostrøm?",
              text:
                "For å se bilder fra NVEs fotostrøm må du aktivere dette ved hjelp av knappen 'Vis fotostrøm' nede til høyre i kartet."
            },
            {
              title: "Hvilke oppstartsparametere støtter løsningen?",
              text:
                "Løsningen støtter følgende oppstartsparametere når et tema lastes inn: <i>extent</i>, <i>layer</i>, <i>field</i>, <i>value</i> og <i>buffer</i>.<br/><br/> Disse oppstartsparameterne kan brukes når man laster inn et gitt tema, dvs. oppstartsparametere må følge etter URLen til temaet, f.eks. etter " +
                this.appPublicUrl +
                "/tema/kvikkleire. <br/><br/>Man kan ikke bruke alle parameterne samtidig. Enten bruker man kun extent (for å zoome kartet til en gitt extent), eller layer, field, value og buffer samtidig - for å zoome kartet til et gitt element.<br/><br/>Layer er indexen til kartlaget. Field er feltet man skal bruke for å finne rett element. Value er verdien feltet må ha. Buffer angir bufferen rundt elementet i meter (hvis man ønsker at kartet skal zoomes litt ut fra elementet).<br/><br/>Eksempel på bruk av oppstartsparametere: " +
                this.appPublicUrl +
                "/tema/kvikkleire?layer=0&field=skredOmrID&value=123&buffer=1000.<br/><br/> Extent angis i euref89 utm33 koordinater, i følgende format extent=xmin|ymin|xmax|ymax. Eksempel på bruk av extent oppstartsparameter: " +
                this.appPublicUrl +
                "/tema/kvikkleire?extent=194486|6985649|244905|7041741.<br/><br/>" +
                "Man kan også zoome direkte til et punkt vha. oppstartsparametere, og må da angi x og y koordinater, zoom (1-17) og wkid for koordinatsystemet. F.eks: " +
                this.appPublicUrl +
                "/tema/elvenett?point=true&x=97902&y=6894843&zoom=8&wkid=25833"
            },
            {
              title:
                "Hva gjør jeg hvis jeg ikke finner svaret jeg leter etter her?",
              text:
                'Hvis du ikke har funnet svaret du leter etter her så er du velkommen til å <a href="mailto:gisstotte@nve.no?Subject=' +
                this.appHelpEmailSubject +
                '" target="_top">sende oss en epost.</a>'
            }
          ]
        }
      ]
    };
  }
};
</script>

<style></style>
